import {
  LOCALE_ADD_CATALOG,
  LOCALE_SET_LANGUAGE
} from "../actions/action-types";
import { getDefaultLocale } from "../utils/i18n";

export const localeReducer = (
  state = { language: getDefaultLocale(), catalogs: {} },
  action
) => {
  if (action.type === LOCALE_ADD_CATALOG) {
    return {
      ...state,
      catalogs: { [action.locale]: action.catalog }
    };
  }
  if (action.type === LOCALE_SET_LANGUAGE) {
    return {
      ...state,
      language: action.language
    };
  }

  return state;
};
